module.exports = __webpack_public_path__ + "img/dinamo.41fd29c9.png";